import { CanonicalPeriodValue } from '../../components/climateAnalytics/common'

export type ViewSpec = {
  use_facet_defaults: boolean
  facet_query?: Record<string, any> | null
  canonical_periods?: CanonicalPeriodValue[]
  agg_params?: {
    by?: string[]
    collapse?: string[]
    op?: 'mean' | 'max' | 'min' | 'sum' | 'mode'
    to_scalar?: boolean
  }
}

export const METRIC_VIEWS: Record<string, ViewSpec> = {
  'fld:score': {
    use_facet_defaults: true,
    agg_params: { by: ['period_canonical'] },
    canonical_periods: ['short', 'mid', 'long'],
  },
  'fld:depth': {
    use_facet_defaults: false,
    facet_query: {
      statistic: 'mean',
      defended: false,
    },
    agg_params: { by: ['source', 'return_period'] },
  },
  'fld:affected_area': {
    use_facet_defaults: false,
    facet_query: {
      defended: false,
    },
    agg_params: { by: ['source', 'return_period'] },
  },
  'fld:average_damage_ratio': {
    use_facet_defaults: true,
    agg_params: { by: ['period_canonical', 'target', 'source'] },
    canonical_periods: ['short', 'mid', 'long'],
  },
  'fld:damage_loss': {
    use_facet_defaults: true,
    agg_params: { by: ['source', 'target', 'return_period'] },
  },
  'fld:damage_ratio': {
    use_facet_defaults: true,
    agg_params: { by: ['source', 'target', 'return_period'] },
  },
  'fld:average_damage_loss': {
    use_facet_defaults: true,
    agg_params: { by: ['period_canonical', 'target', 'source'] },
    canonical_periods: ['short', 'mid', 'long'],
  },
  'fld:average_bi_loss': {
    use_facet_defaults: true,
    agg_params: { by: ['period_canonical', 'source'] },
    canonical_periods: ['short', 'mid', 'long'],
  },
  'fld:bi_loss': {
    use_facet_defaults: true,
    agg_params: { by: ['source', 'return_period'] },
  },
  'fld:average_bi_days': {
    use_facet_defaults: true,
    agg_params: { by: ['period_canonical', 'source'] },
    canonical_periods: ['short', 'mid', 'long'],
  },
  'fld:bi_days': {
    use_facet_defaults: true,
    agg_params: { by: ['source', 'return_period'] },
  },
  'hs:heat_scores': {
    use_facet_defaults: false,
    facet_query: {
      statistic: 'mean',
    },
    agg_params: { by: ['period_canonical'], to_scalar: true },
    canonical_periods: ['short', 'mid', 'long'],
  },
  'hs:hot_days': {
    use_facet_defaults: false,
    facet_query: {
      statistic: 'mean',
    },
    agg_params: { by: ['period_canonical'], to_scalar: true },
    canonical_periods: ['short', 'mid', 'long'],
  },
  'tc:score': {
    use_facet_defaults: false,
    agg_params: { to_scalar: true },
  },
  'tc:average_damage_loss': {
    use_facet_defaults: false,
    agg_params: { to_scalar: true },
  },
  'tc:damage_loss': {
    use_facet_defaults: false,
    agg_params: { by: ['return_period'] },
  },
  'tc:average_damage_ratio': {
    use_facet_defaults: false,
    agg_params: { to_scalar: true },
  },
  'tc:damage_ratio': {
    use_facet_defaults: false,
    agg_params: { by: ['return_period'] },
  },
  'tc:average_bi_loss': {
    use_facet_defaults: false,
    agg_params: { to_scalar: true },
  },
  'tc:bi_loss': {
    use_facet_defaults: false,
    agg_params: { by: ['return_period'] },
  },
  'tc:average_bi_days': {
    use_facet_defaults: false,
    agg_params: { to_scalar: true },
  },
  'tc:bi_days': {
    use_facet_defaults: false,
    agg_params: { by: ['return_period'] },
  },
  'tc:wind_speed': {
    use_facet_defaults: false,
    facet_query: {
      variable: 'statistic',
      member: 'ensemble',
    },
    agg_params: { by: ['return_period'], to_scalar: true },
  },
  'wind_gust:score': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: { by: ['period_canonical'], to_scalar: true },
  },
  'wind_gust:average_damage_loss': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: { by: ['period_canonical'], to_scalar: true },
  },
  'wind_gust:damage_loss': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: { by: ['period_canonical', 'return_period'] },
  },
  'wind_gust:average_damage_ratio': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: { by: ['period_canonical'], to_scalar: true },
  },
  'wind_gust:damage_ratio': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: { by: ['period_canonical', 'return_period'] },
  },
  'wind_gust:average_bi_loss': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: { by: ['period_canonical'], to_scalar: true },
  },
  'wind_gust:bi_loss': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: { by: ['period_canonical', 'return_period'] },
  },
  'wind_gust:average_bi_days': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: { by: ['period_canonical'], to_scalar: true },
  },
  'wind_gust:bi_days': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: { by: ['period_canonical', 'return_period'] },
  },
  'wind_gust:gust_speed': {
    use_facet_defaults: true,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: { by: ['period_canonical', 'return_period'], to_scalar: true },
  },
  'freeze_thaw:score': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: { by: ['period_canonical'], to_scalar: true },
  },
  'freeze_thaw:freeze_thaw_days': {
    use_facet_defaults: true,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: { by: ['period_canonical'], to_scalar: true },
  },
  'wr:ws': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['variable', 'period_canonical'],
      to_scalar: true,
    },
  },
  'wr:ws_info': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['variable', 'period_canonical'],
      op: 'mode',
      to_scalar: true,
    },
  },
  'wr:ba': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    facet_query: {
      variable: 'raw',
    },
    agg_params: {
      by: ['period_canonical'],
      to_scalar: true,
    },
  },
  'wr:ww': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    facet_query: {
      variable: 'raw',
    },
    agg_params: {
      by: ['period_canonical'],
      to_scalar: true,
    },
  },
  'wr:ba_info': {
    use_facet_defaults: true,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['period_canonical'],
      op: 'mode',
      to_scalar: true,
    },
  },
  'wr:ww_info': {
    use_facet_defaults: true,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['period_canonical'],
      op: 'mode',
      to_scalar: true,
    },
  },
  'wr:wd': {
    use_facet_defaults: true,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['period_canonical'],
      to_scalar: true,
    },
  },
  'wr:wd_info': {
    use_facet_defaults: true,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['period_canonical'],
      op: 'mode',
      to_scalar: true,
    },
  },
  'wr:sv': {
    use_facet_defaults: true,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['period_canonical'],
      to_scalar: true,
    },
  },
  'wr:sv_info': {
    use_facet_defaults: true,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['period_canonical'],
      op: 'mode',
      to_scalar: true,
    },
  },
  'wr:iv': {
    use_facet_defaults: true,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['period_canonical'],
      to_scalar: true,
    },
  },
  'wr:iv_info': {
    use_facet_defaults: true,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['period_canonical'],
      op: 'mode',
      to_scalar: true,
    },
  },
  'wf:score': {
    use_facet_defaults: true,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['period_canonical'],
      to_scalar: true,
    },
  },
  'wf:damage_loss': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['period_canonical', 'target'],
    },
  },
  'wf:bi_loss': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['period_canonical'],
      to_scalar: true,
    },
  },
  'wf:damage_ratio': {
    use_facet_defaults: false,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['period_canonical'],
      to_scalar: true,
    },
  },
  'wf:bi_days': {
    use_facet_defaults: true,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['period_canonical'],
      to_scalar: true,
    },
  },
  'wf:damage_loss_rp': {
    use_facet_defaults: false,
    agg_params: {
      by: ['target', 'return_period'],
    },
  },
  'wf:bi_loss_rp': {
    use_facet_defaults: false,
    agg_params: {
      by: ['return_period'],
    },
  },
  'wf:damage_ratio_rp': {
    use_facet_defaults: false,
    agg_params: {
      by: ['return_period'],
    },
  },
  'wf:bi_days_rp': {
    use_facet_defaults: false,
    agg_params: {
      by: ['return_period'],
    },
  },
  'wf:days_above_fwi_threshold': {
    use_facet_defaults: false,
    facet_query: {
      statistic: 'mean',
    },
    agg_params: {
      by: ['threshold'],
    },
  },
  'wf:fires': {
    use_facet_defaults: true,
    canonical_periods: ['short', 'mid', 'long'],
    agg_params: {
      by: ['period_canonical'],
      to_scalar: true,
    },
  },
}

export function parseMetricKey(key: string) {
  const [hazard, code] = key.split(':')
  if (!hazard || !code) throw new Error('Metric key must be "hazard:code"')
  return { hazard, code }
}
